function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from 'react';
import { useTheme } from 'styled-components';
function PlaySVG(props) {
  var theme = useTheme();
  var colors = theme.colors;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32",
    height: "32",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M12 22.1315V9.86852C12 9.06982 12.8901 8.59343 13.5547 9.03647L22.7519 15.1679C23.3457 15.5638 23.3457 16.4362 22.7519 16.8321L13.5547 22.9635C12.8901 23.4066 12 22.9302 12 22.1315Z",
    fill: colors.textInverse
  }));
}
export default PlaySVG;